import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Performer } from 'src/app/store/performers.era';
import { Sponsor } from 'globals/store/sponsors.data';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { select } from '@ngrx/store';
import { Wrapper } from '../wrapper.component';
import { Asset } from 'globals/store/assets.data';
import { assetListReselector } from '../../store/reselectors/entity.reselector';
import { EntityName } from 'globals/store/entity.data';
import { JoiResource } from 'globals/store/resources.data';
import { performerListReselector, sponsorListReselector, exhibitorListReselector, resourceListReselector, attendeeListReselector } from '../../store/reselectors/entity.decircular.reselector';
import { Attendee } from 'globals/store/attendees.data';
import { getOneStorePromise } from 'src/app/store/ui.era';
import { SearchBarComponent } from '../search-bar';
import { CommonModule } from '@angular/common';
import { DialogWrapperComponent } from '../wrappers/dialog-wrapper.component';
import { ToggleButtonWrapperComponent } from '../buttons/toggle-button-wrapper.component';
import { PerformerCardComponent } from '../cards/performer-card.component';
import { AssetCardComponent } from '../cards/asset-card.component';
import { SponsorCardComponent } from '../cards/sponsor-card.component';

@Component({
    selector: 'all-entity-selector',
    templateUrl: './all-entity-select.dialog.html',
    styles: [`
    h5 { margin-top: 20px; }
    .grey-hint { margin-top: 5px; font-size: 14px; }
    .toggle-button { display: block; margin-top: 5px; }
  `],
    standalone: true,
    imports: [SearchBarComponent, CommonModule, DialogWrapperComponent, ToggleButtonWrapperComponent, PerformerCardComponent, AssetCardComponent, SponsorCardComponent],
})
export class AllEntitySelectDialogComponent extends Wrapper<AllEntitySelectDialogComponent> implements OnInit {

  sponsorList: Sponsor[] = []
  performerList: Performer[] = []
  exhibitorList: Exhibitor[] = []
  assetList: Asset[] = []
  resourceList: JoiResource[] = []
  attendeeList: Attendee[] = []

  sponsorsToShow: Sponsor[] = []
  performersToShow: Performer[] = []
  exhibitorsToShow: Exhibitor[] = []
  assetsToShow: Asset[] = []
  resourcesToShow: JoiResource[] = []
  attendeesToShow: Attendee[] = []


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AllEntitySelectData,
    public dialogRef: MatDialogRef<AllEntitySelectDialogComponent>,
  ) {
    super()
    getOneStorePromise(this.store, select(performerListReselector)).then(list => {
      this.performerList = list
      this.onSearchInput(null)
    })
    getOneStorePromise(this.store, select(sponsorListReselector)).then(list => {
      this.sponsorList = list
      this.onSearchInput(null)
    })
    getOneStorePromise(this.store, select(exhibitorListReselector)).then(list => {
      this.exhibitorList = list
      this.onSearchInput(null)
    })
    getOneStorePromise(this.store, select(assetListReselector)).then(list => {
      this.assetList = list
      this.onSearchInput(null)
    })
    getOneStorePromise(this.store, select(resourceListReselector)).then(list => {
      this.resourceList = list
      this.onSearchInput(null)
    })
    getOneStorePromise(this.store, select(attendeeListReselector)).then(list => {
      this.attendeeList = list
      this.onSearchInput(null)
    })
  }


  ngOnInit() {
    const { rect } = this.data
    this.dialogRef.updatePosition({ top: rect.y + 'px', left: rect.left + 'px' })
  }
  onSearchInput(term: string) {
    if (!term) { // both for initialization as well as empty searches
      this.performersToShow = this.performerList
      this.sponsorsToShow = this.sponsorList
      this.exhibitorsToShow = this.exhibitorList
      this.assetsToShow = this.assetList
      this.resourcesToShow = this.resourceList
      this.attendeesToShow = this.attendeeList
      return
    }
    term = term.toLocaleLowerCase()
    this.performersToShow = this.performerList.filter(entity => entity.name.toLocaleLowerCase().includes(term))
    this.sponsorsToShow = this.sponsorList.filter(entity => entity.name.toLocaleLowerCase().includes(term))
    this.exhibitorsToShow = this.exhibitorList.filter(entity => entity.name.toLocaleLowerCase().includes(term))
    this.assetsToShow = this.assetList.filter(entity => entity.name.toLocaleLowerCase().includes(term))
    this.resourcesToShow = this.resourceList.filter(entity => entity.name.toLocaleLowerCase().includes(term))
    this.attendeesToShow = this.attendeeList.filter(entity => entity.name.toLocaleLowerCase().includes(term))
  }

  selectEntity(id: string, type: EntityName) {
    this.data.selectedId = id === this.data.selectedId ? null : id
    this.data.selectedType = !this.data.selectedId ? null : type 
    this.dialogRef.close()
    // console.log({ id, selectedId: this.data.selectedId })
  }
  
  trackByEntity(index, entity: Performer | Sponsor | Exhibitor | Asset | JoiResource | Attendee) {
    return entity.id
  }
  


}

export interface AllEntitySelectData {
  selectedId: string
  selectedType?: EntityName
  rect: DOMRect
  includeAssets?: boolean
  includeResources?: boolean
  includeAttendees?: boolean
}